module.exports = __webpack_public_path__ + "908e4d2e/img/pwrd-by-sourcery-black.bba9ba41.svg";